export default __webpack_public_path__ + "static/support-sponsor-flaunt-it-2c3b886948065d9d78916f4163d6d0a0.png";